import { CreateButton, FilterButton, TopToolbar } from 'react-admin'

const NumberRangeListActions = () => {
  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton variant='contained' color='success' />
    </TopToolbar>
  )
}

export default NumberRangeListActions